import React, { useState } from "react";
import { useAppText } from "src/commun/composants/AppText";
import AppInput from "src/commun/composants/formulaire/AppInput/AppInput";
import { useAppState } from "src/app/state/StateProvider";
import AppIcon from "src/commun/composants/AppIcon";
import { GenericApiResponse } from "src/app/api/AppApiClient";
import { FormikValues } from "formik";
import { deleteMobile, fetchUser, setMobile } from "src/app/api/AccountApi";
import { CheckTelephoneCode } from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneCheck/useValidationSchemaTelephoneCode";
import { VerificationTelephone } from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneSend/useValidationSchemaTelephone";
import CodeTelephoneSendForm from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneSend/CodeTelephoneSendForm";
import CodeTelephoneCheckForm from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneCheck/CodeTelephoneCheckForm";
import ConfirmationPopin from "src/commun/composants/ConfirmationPopIn/ConfirmationPopin";
import AppPopin from "src/commun/composants/AppPopin/AppPopin";

export type MobileUpdateProps = {
  readOnly: boolean;
}

const MobileUpdate = ({ readOnly }: MobileUpdateProps) => {
  const [{ user }, dispatch] = useAppState();
  const { tString } = useAppText();
  const [mobileEditedSuccessfully, setMobileEditedSuccessfully] = useState(false);
  const [mobileDeletedSuccessfully, setMobileDeletedSuccessfully] = useState(false);
  const [editMobile, setEditMobile] = useState(false);
  const [confirmDeleteMobile, setConfirmDeleteMobile] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [newMobile, setNewMobile] = useState("");

  const handleStepPrecedente = () => {
    setCurrentStep(currentStep - 1);
  }

  const handleStepSuivante = (result: GenericApiResponse<any>, values: FormikValues) => {
    setCurrentStep(currentStep + 1);
    setNewMobile(values.mobileNumber);
  }

  const startEditMobile = () => {
    setEditMobile(true);
    setMobileEditedSuccessfully(false);
    setMobileDeletedSuccessfully(false);
  }

  const endEditMobile = () => {
    setEditMobile(false);
    setCurrentStep(0);
  }

  const deleteMobileHandler = () => {
    deleteMobile().then(() => {
      setConfirmDeleteMobile(false);
      setMobileDeletedSuccessfully(true);
      fetchUser().then(result => {
        dispatch({ type: "setUser", payload: result });
      });
    })
  }

  const submitFormAPI = (values: CheckTelephoneCode) => setMobile(values);

  return (
    <>
      {!editMobile ?
        (
          <>
            <div style={{ display: !readOnly ? "inline-flex" : "" }}>
              <div className="input btn__filter--disabled">
                <AppInput name="currentMobile" value={user!.mobileNumber} onChange={() => {
                }}/>
                <label>{tString("compte.mon.profile.mobile")}</label>
              </div>
              {!readOnly &&
                <>
                  <div className="d-inline cursor-pointer">
                    <AppIcon name="diter" active size="38px" onClick={startEditMobile}/>
                  </div>
                  {user!.mobileNumber &&
                    <div className="d-inline cursor-pointer">
                      <AppIcon name="poubelle" active size="38px" onClick={() => setConfirmDeleteMobile(true)}/>
                    </div>
                  }
                </>

              }
            </div>
            {mobileEditedSuccessfully && <p>{tString("update.mobile.success.message")}</p>}
            {mobileDeletedSuccessfully && <p>{tString("update.mobile.delete.success.message")}</p>}
          </>
        )
        :
        (
          <>
            {currentStep === 0 && (
              <>
                {tString("update.mobile.message")}
                <CodeTelephoneSendForm
                  initialValues={{} as VerificationTelephone}
                  submitSuccessHandler={handleStepSuivante}
                  displayCancelBtn={true}
                  cancelCallback={endEditMobile}/>
              </>
            )}
            {currentStep === 1 &&
              <CodeTelephoneCheckForm
                initialValues={{ mobileNumber: newMobile } as CheckTelephoneCode}
                submitSuccessHandler={() => {
                  setMobileEditedSuccessfully(true);
                  endEditMobile();
                  fetchUser().then(result => {
                    dispatch({ type: "setUser", payload: result });
                  });
                }}
                stepPrecedente={handleStepPrecedente}
                submitFormAPI={submitFormAPI}
                displayCancelBtn={true}
                cancelCallback={endEditMobile}/>
            }
          </>
        )}

      <AppPopin
        opened={confirmDeleteMobile}
        onModalClick={() => setConfirmDeleteMobile(false)}
      >
        <ConfirmationPopin
          text="update.mobile.delete.message"
          validerLabel="update.mobile.delete.button"
          validerHandler={deleteMobileHandler}
          annulerLabel="update.mobile.cancel.button"
          annulerHandler={() => setConfirmDeleteMobile(false)}
        />
      </AppPopin>
    </>
  );
};

export default MobileUpdate;